import { Flex, Spin } from 'antd';

/** What the page shows while the first route's code is still being loaded (the routes are lazy). */
export function InitialLoading() {
  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Spin size="large" />
    </Flex>
  );
}
